import { cdmApi } from '../API';

const reducers = {
    [cdmApi.reducerPath]: cdmApi.reducer,
};

export default reducers;
